(function () {
  'use strict';

  var STORAGE_KEY = 'edd_delivery';
  var LEGACY_KEY = 'edd_pincode';
  var UPDATE_EVENT = 'rabitat:edd:updated';
  var instances = new WeakMap();

  function getSavedDelivery() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        return JSON.parse(raw);
      }

      var legacyPincode = localStorage.getItem(LEGACY_KEY);
      if (legacyPincode && /^[1-8][0-9]{5}$/.test(legacyPincode)) {
        return { pincode: legacyPincode };
      }
    } catch (e) {
      return null;
    }

    return null;
  }

  function saveDelivery(pincode, deliveryDate) {
    var existing = getSavedDelivery();
    if (
      existing &&
      existing.pincode === pincode &&
      existing.deliveryDate === deliveryDate
    ) {
      return false;
    }

    var payload = {
      pincode: pincode,
      deliveryDate: deliveryDate,
      timelineDate: deliveryDate
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    localStorage.setItem(LEGACY_KEY, pincode);
    document.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: payload }));
    return true;
  }

  function CartEddStrip(root) {
    this.root = root;
    this.resultEl = root.querySelector('[data-cart-edd-result]');
    this.formEl = root.querySelector('[data-cart-edd-form]');
    this.inputEl = root.querySelector('[data-cart-edd-input]');
    this.submitEl = root.querySelector('[data-cart-edd-submit]');
    this.errorEl = root.querySelector('[data-cart-edd-error]');
    this.dateEl = root.querySelector('[data-cart-edd-date]');
    this.pincodeEl = root.querySelector('[data-cart-edd-pincode]');
    this.labelEl = root.querySelector('[data-cart-edd-label]');
    this.changeEl = root.querySelector('[data-cart-edd-change]');
    this.apiUrl = (root.dataset.apiUrl || '').trim();
    this.pickupPincode = root.dataset.pickupPincode || '121004';
    this.weight = parseFloat(root.dataset.weight) || 0.5;
    this.cod = root.dataset.cod === 'true';
    this.deliveryLabel = root.dataset.deliveryLabel || 'Free delivery';
    this.requestId = 0;
    this.lastCheckedPincode = '';
    this.editingPincode = false;

    if (this.apiUrl.startsWith('/')) {
      this.apiUrl = window.location.origin + this.apiUrl;
    }

    instances.set(root, this);
    this.bindEvents();
    this.applySavedState();
  }

  CartEddStrip.prototype.bindEvents = function () {
    var self = this;

    if (this.formEl) {
      this.formEl.addEventListener('submit', function (event) {
        event.preventDefault();
        self.checkDelivery();
      });
    }

    if (this.inputEl) {
      this.inputEl.addEventListener('input', function () {
        var pincode = self.inputEl.value.replace(/\D/g, '').slice(0, 6);
        self.inputEl.value = pincode;
        self.hideError();

        if (pincode.length === 6 && pincode !== self.lastCheckedPincode) {
          self.checkDelivery();
        }
      });
    }

    if (this.changeEl) {
      this.changeEl.addEventListener('click', function () {
        self.editingPincode = true;
        self.showForm();
        if (self.inputEl) {
          self.inputEl.focus();
          self.inputEl.select();
        }
      });
    }
  };

  CartEddStrip.prototype.hideError = function () {
    if (!this.errorEl) return;
    this.errorEl.hidden = true;
    this.errorEl.textContent = '';
  };

  CartEddStrip.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.hidden = false;
    this.errorEl.textContent = message;
  };

  CartEddStrip.prototype.showResult = function (pincode, deliveryDate) {
    if (this.labelEl) {
      this.labelEl.textContent = this.deliveryLabel;
    }
    if (this.dateEl) {
      this.dateEl.textContent = deliveryDate;
    }
    if (this.pincodeEl) {
      this.pincodeEl.textContent = pincode;
    }
    if (this.resultEl) {
      this.resultEl.hidden = false;
    }
    if (this.formEl) {
      this.formEl.hidden = true;
    }
    this.editingPincode = false;
    this.hideError();
  };

  CartEddStrip.prototype.showForm = function () {
    if (this.resultEl) {
      this.resultEl.hidden = true;
    }
    if (this.formEl) {
      this.formEl.hidden = false;
    }
    this.hideError();
  };

  CartEddStrip.prototype.applySavedState = function () {
    if (this.editingPincode) return;

    var saved = getSavedDelivery();

    if (!saved || !saved.pincode || !/^[1-8][0-9]{5}$/.test(saved.pincode)) {
      this.showForm();
      return;
    }

    if (this.inputEl) {
      this.inputEl.value = saved.pincode;
    }
    this.lastCheckedPincode = saved.pincode;

    if (saved.deliveryDate) {
      this.showResult(saved.pincode, saved.deliveryDate);
      return;
    }

    this.showForm();
  };

  CartEddStrip.prototype.checkDelivery = function () {
    if (!this.inputEl) return;

    var pincode = this.inputEl.value.trim();
    if (!/^[1-8][0-9]{5}$/.test(pincode)) {
      if (pincode.length === 6) {
        this.showError('Please enter a valid 6-digit Indian pincode.');
      }
      return;
    }

    var saved = getSavedDelivery();
    if (saved && saved.pincode === pincode && saved.deliveryDate) {
      this.lastCheckedPincode = pincode;
      this.showResult(pincode, saved.deliveryDate);
      return;
    }

    if (pincode === this.lastCheckedPincode && this.resultEl && !this.resultEl.hidden) {
      return;
    }

    if (this.apiUrl) {
      this.fetchDelivery(pincode);
    }
  };

  CartEddStrip.prototype.fetchDelivery = function (pincode) {
    var self = this;
    var requestId = ++this.requestId;

    if (this.submitEl) {
      this.submitEl.disabled = true;
    }

    var params = new URLSearchParams({
      pincode: pincode,
      pickup_pincode: this.pickupPincode,
      weight: String(this.weight),
      cod: this.cod ? '1' : '0'
    });

    fetch(this.apiUrl + '?' + params.toString())
      .then(function (response) {
        if (!response.ok) {
          throw new Error('API request failed (' + response.status + ')');
        }
        return response.json();
      })
      .then(function (data) {
        if (requestId !== self.requestId) return;

        if (!data.success) {
          throw new Error(data.message || 'Unable to check delivery for this pincode.');
        }

        var label = data.delivery_label || data.delivery_date;
        self.lastCheckedPincode = pincode;
        saveDelivery(pincode, label);
        self.showResult(pincode, label);
      })
      .catch(function (error) {
        if (requestId !== self.requestId) return;

        self.showForm();
        self.showError(
          error && error.message
            ? error.message
            : 'Unable to fetch delivery date. Please try again.'
        );
      })
      .finally(function () {
        if (requestId === self.requestId && self.submitEl) {
          self.submitEl.disabled = false;
        }
      });
  };

  function initCartEdd(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    new CartEddStrip(root);
  }

  function refreshCartEdd() {
    document.querySelectorAll('[data-cart-edd]').forEach(initCartEdd);
  }

  function syncCartEddFromStorage() {
    document.querySelectorAll('[data-cart-edd]').forEach(function (root) {
      var instance = instances.get(root);
      if (instance) {
        instance.applySavedState();
      } else {
        initCartEdd(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartEdd);
  } else {
    refreshCartEdd();
  }

  document.addEventListener('shopify:section:load', refreshCartEdd);
  document.addEventListener(UPDATE_EVENT, syncCartEddFromStorage);
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY || event.key === LEGACY_KEY) {
      syncCartEddFromStorage();
    }
  });

  window.RabitatCartEdd = {
    refresh: refreshCartEdd
  };
})();
